/**
 * @generated SignedSource<<4120494f1f59f8ff5ee086da15463f48>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type LastIssueUpdateCell$data = {
  readonly lastUpdatedDisplayDate: string | null | undefined;
  readonly lastUpdatedToolTipDate: string | null | undefined;
  readonly " $fragmentType": "LastIssueUpdateCell";
};
export type LastIssueUpdateCell$key = {
  readonly " $data"?: LastIssueUpdateCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"LastIssueUpdateCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "LastIssueUpdateCell",
  "selections": [
    {
      "alias": "lastUpdatedToolTipDate",
      "args": [
        {
          "kind": "Literal",
          "name": "format",
          "value": "COMPLETE_DATETIME_FORMAT"
        }
      ],
      "kind": "ScalarField",
      "name": "lastUpdatedFormatted",
      "storageKey": "lastUpdatedFormatted(format:\"COMPLETE_DATETIME_FORMAT\")"
    },
    {
      "alias": "lastUpdatedDisplayDate",
      "args": [
        {
          "kind": "Literal",
          "name": "format",
          "value": "RELATIVE"
        }
      ],
      "kind": "ScalarField",
      "name": "lastUpdatedFormatted",
      "storageKey": "lastUpdatedFormatted(format:\"RELATIVE\")"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "e1560cdd696af8494c270f87abd56087";

export default node;
